import { servletDelete, servletGet, servletGetAll, servletGetResults, servletPost, servletSave } from '../helpers';
import join from 'url-join';
import _ from 'underscore';

export default class crud {
  constructor(url) {
    this._url = url;
  }

  get(params = {}, ...args) {
    if (typeof params !== 'object') {
      return Promise.reject(new Error('Invalid params'));
    }

    return servletGet(this._url, params, ...args);
  }

  getSingle(id) {
    if (typeof id !== 'string') {
      return Promise.reject(new Error('Invalid ID'));
    }

    return servletGetResults(join(this._url, id));
  }

  getAll(...args) {
    return servletGetAll(this._url, ...args);
  }

  save(...args) {
    return servletSave(this._url, ...args);
  }

  complete(id, params) {
    const url = join(this._url, id, 'complete');
    return servletPost(url, params);
  }

  destroyAll(params, ...args) {
    if (typeof params !== 'object') {
      return Promise.reject(new Error('Invalid params'));
    }

    return servletDelete(this._url, params, ...args);
  }

  destroyId(id, additionalParams) {
    if (typeof id !== 'string') {
      return Promise.reject(new Error('Invalid ID'));
    }

    return servletDelete(this._url, id, additionalParams);
  }

  destroyIds(idArray, additionalParams) {
    if (!_.isArray(idArray)) {
      return Promise.reject(new Error('ID array is required parameter'));
    }

    if (_.uniq(idArray).length !== idArray.length) {
      return Promise.reject(new Error('Duplicate IDs'));
    }

    if (idArray.length === 0) {
      return Promise.resolve();
    }

    return Promise.all(idArray.map(id => this.destroyId(id, additionalParams)));
  }
}


// WEBPACK FOOTER //
// ./src/js/util/dao/helpers/crud.jsx